import { getUser } from "@braze/web-sdk";
import { logger } from "@origin-digital/reporting-client";
import { guid } from "@origin-digital/platform-helpers";
import { IBrazeInit } from "../consts/interfaces";

export const DATASOURCE_GENERATOR_KEY = "datasource_generator";
export const DATASOURCE_GENERATOR_VALUE = "WEB_SDK";

export const loadBrazeSdkUserId = (): Promise<string | undefined> =>
  new Promise((resolve) => {
    getUser()?.getUserId((userId: string | null) => {
      if (userId == null) {
        logger.warn("[braze] initialized - getUser() returned null userId");
      }
      return resolve(userId ?? undefined);
    });
    resolve(undefined); // if getUser == null
  });

export const findOrCreateNewBrazeUser = async (
  brazeObj: IBrazeInit
): Promise<{
  bzid: string | undefined;
  created: boolean;
}> => {
  if (brazeObj.hasSdkInit) {
    const bzid = await loadBrazeSdkUserId();
    if (bzid) return { bzid, created: false };
  }

  if (
    brazeObj.bzid == null &&
    (brazeObj.hasOriginReferrer ||
      brazeObj.hasWhiteListedPath ||
      brazeObj.hasSdkInit)
  ) {
    const bzid = guid();
    getUser()?.setCustomUserAttribute(
      DATASOURCE_GENERATOR_KEY,
      DATASOURCE_GENERATOR_VALUE
    );
    return { bzid, created: true };
  }

  // case when user may be removed from braze (after 6 months)
  // but we still known the customers bzid from the cookie
  if (brazeObj.bzid != null && brazeObj.created) {
    getUser()?.setCustomUserAttribute(
      DATASOURCE_GENERATOR_KEY,
      DATASOURCE_GENERATOR_VALUE
    );
    return { bzid: brazeObj.bzid, created: true };
  }

  return { bzid: undefined, created: false };
};
